import { HttpErrorResponse } from '@angular/common/http';

export class UnauthorizedError extends Error {
    httpStatus = 401;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, UnauthorizedError.prototype);
    }
}
